// Ряд входов генерации: кадры, элементы и (позже) референсные картинки стоят в
// одну строку колонками с подписями, а не отдельными этажами над промптом.
// Каналы у провайдера разные, но человеку это один вопрос «что я даю модели», и
// раскладка одинакова во всех режимах, где канал объявлен.
//
// Колонка «Референсы» зарезервирована структурно: подключённый провайдер её пока
// не объявляет, поэтому caller не передаёт содержимое и колонка не рисуется —
// мёртвого UI в баре нет.

import { useTranslation } from "react-i18next";

import { GENERATION_INPUT_CHANNELS, inputChannelTitleKey } from "~/entities/chat";
import { cn } from "~/shared/lib/utils";

import type { ReactNode } from "react";

export interface PromptInputsRowProps {
    frames?: ReactNode;
    elements?: ReactNode;
    references?: ReactNode;
    video?: ReactNode;
    audio?: ReactNode;
}

export function PromptInputsRow({ frames, elements, references, video, audio }: PromptInputsRowProps) {
    const { t } = useTranslation("chat");

    // Порядок и заголовки колонок — из общего описания каналов: тем же живёт блок
    // входов в сообщении, поэтому новый канал появляется на обоих экранах сразу.
    const contentByChannel = { frames, elements, references, video, audio };
    const columns = GENERATION_INPUT_CHANNELS.map((key) => ({
        key,
        content: contentByChannel[key],
    })).filter((column) => column.content !== undefined && column.content !== null);

    if (columns.length === 0) return null;

    return (
        <div className="mb-1.5 flex flex-wrap items-start gap-x-4 gap-y-3 px-1 py-2">
            {columns.map((column, index) => (
                <div
                    key={column.key}
                    className={cn("flex flex-col gap-1.5", index > 0 && "border-l border-white/5 pl-4")}
                >
                    {/* Тот же вид, что у заголовков групп в панели настроек
                        (`SettingsTiles`): роль одна — назвать группу контролов,
                        поэтому и оформление одно. Капс держит заголовок над
                        подписями слотов, не перебивая их яркостью. */}
                    <span className="text-[11px] font-medium tracking-[0.12em] text-zinc-500 uppercase">
                        {t(inputChannelTitleKey(column.key))}
                    </span>
                    {column.content}
                </div>
            ))}
        </div>
    );
}
